var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThumbsDownIcon = function SvgThumbsDownIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.75 13.063h4.125V4.124H2.75a.69.69 0 0 0-.687.688v7.562a.687.687 0 0 0 .687.688M6.875 13.063l3.438 6.874a2.75 2.75 0 0 0 2.75-2.75v-2.062h5.319a1.366 1.366 0 0 0 1.358-1.547l-1.031-8.25a1.375 1.375 0 0 0-1.358-1.203H6.875"
  })));
};
export default SvgThumbsDownIcon;